import React from 'react';
import { connect } from '@gasbuddy/react';
import MainLayout from '../../components/main-layout';

/* eslint-disable react/prefer-stateless-function */
class CompetitorBenchmarking extends React.Component {
  // b/c the MainLayout is required to have children components (markup inside the component tag)
  // we put this <div> does nothing, it will be removed at a later time when we have only components to put inside of it
  render() {
    return (
      <MainLayout title="Competitor Benchmarking">
        <div>
          this is the competitor benchmarking page.
        </div>
      </MainLayout>
    );
  }
}

export default connect()(CompetitorBenchmarking);
